exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.are-you-sure-wrapper[data-v-68227446] {\n  padding: 15px 15px 0 15px;\n}\n.are-you-sure-actions[data-v-68227446] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: distribute;\n      justify-content: space-around;\n}\n.opacity-2[data-v-68227446] {\n  opacity: 0.2;\n}\n.loader-circle[data-v-68227446] {\n  margin-bottom: 30px;\n  border: 3px solid rgba(0, 0, 0, 0);\n  border-left-color: #2962ff;\n  -webkit-animation: loader-spin 1.2s infinite linear;\n  animation: loader-spin 0.7s infinite linear;\n  display: inline-block;\n  vertical-align: top;\n  border-radius: 50%;\n  width: 70px;\n  height: 70px;\n  z-index: 10000;\n  position: absolute;\n  top: 43%;\n  right: 40%;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68227446","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/jobs/modals/AreYouSureRevertToAccepted.vue
// module id = vaw9
// module chunks = 0